<template>
    <div class="clearfix ">
        <div class="custom-loader-wrapper" v-if="loader">
            <div class="text-center">
                <span class="d-block max-450">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>

            </div>
        </div>
        <b-overlay  rounded="sm" :show="showoverlay" class='payslip-designer-overlay'>
        <div class="clearfix ibox rounded mb-3 pb-5 mx-auto px-3"> <!-- Abdullah added class ibox and removed company-form-container  -->

                <table style="width: 100%;">
                    <tr><td style="width: 25%;"><img :src="$api_url+'/images/company/'+company_data.logo" /></td><td style="width: 30%;">&nbsp;</td><td style="width: 30%;text-align: right;font-size: 10px;">{{company_data.address}}<br/>{{company_data.city}} - {{company_data.zip}}, {{company_data.country}}</td></tr>
                </table>
                <p class="text-center" style="font-weight: bold; font-size: 12pt;margin-bottom: 0; margin-top: 0;">{{ company_data.name }}</p>

                <template v-if="$atl_company_package_title !=  'Provident Fund Only'">
                    <p class="text-center" style="margin-top: 0; font-size: 10pt;"><span style="font-weight: bold;font-size: 12pt;">PAY SLIP</span><br />Income Year 2021-2022</p>
                </template>
                <template v-else>
                    <p class="text-center" style="margin-top: 0; font-size: 10pt;"><span style="font-weight: bold;font-size: 12pt;">PF SLIP</span><br />Income Year 2021-2022</p>
                </template>

                <table style="width: 99%; margin-bottom: -15px;" class="d-table">

                <template v-for="index in data_length" >
                <tr v-if="index == 1">

                    <td :key="index" style="text-align: left; font-size: 9pt; width:22%;"><strong><template v-if="(typeof header_left[index-1] != 'undefined' && header_left[index-1] != null)">{{stringView(header_left[index-1])}}</template></strong></td>  <td style="text-align: left; font-size: 9pt; width:30%;" ><strong><template v-if="(typeof header_left[index-1] != 'undefined' && header_left[index-1] != null)">{{showValue(header_left[index-1])}}</template></strong></td>
                    <td style="text-align: left; font-size: 9pt; width:20%;"><strong><template v-if="(typeof header_right[index-1] != 'undefined' && header_right[index-1] != null)">{{stringView(header_right[index-1])}}</template></strong></td>  <td style="text-align: left; font-size: 9pt; width:30%;"  ><strong><template v-if="(typeof header_right[index-1] != 'undefined' && header_right[index-1] != null)">{{showValue(header_right[index-1])}}</template></strong></td>
                </tr>
                <tr v-else>

                    <td :key="index" style="text-align: left; font-size: 9pt; width:22%;"><template v-if="(typeof header_left[index-1] != 'undefined' && header_left[index-1] != null)">{{stringView(header_left[index-1])}}</template></td>  <td style="text-align: left; font-size: 9pt; width:30%;" ><template v-if="(typeof header_left[index-1] != 'undefined' && header_left[index-1] != null)">{{showValue(header_left[index-1])}}</template></td>
                    <td style="text-align: left; font-size: 9pt;width:20%;"><template v-if="(typeof header_right[index-1] != 'undefined' && header_right[index-1] != null)">{{stringView(header_right[index-1])}}</template></td>  <td style="text-align: left; font-size: 9pt; width:30%;"><template v-if="(typeof header_right[index-1] != 'undefined' && header_right[index-1] != null)">{{showValue(header_right[index-1])}}</template></td>
                </tr>
                </template>

                </table>

                {{lengthCompute}}


        </div>
        <div class="clearfix mb-3 mt-4 text-center">  <!-- Abdullah changed class here was clearfix mb-3 -->
            <button v-on:click="downloadPreview()"  class="btn btn-primary position-static">Download Preview</button> <!-- Abdullah removed class float right-->
        </div>
        </b-overlay>
    </div>

</template>

<script>
    export default{
        props: ['company_data','header_left','header_right','footer','flg','showoverlay'],
        mounted() {
        },
        data(){
            return {
                data_length: 0,
                company_id:0,
                loader:false,
                company_pf_settings:[],
                company_pf_service_month:'no',
                company_package_title:this.$atl_company_package_title,
                default_data:{
                    "name" : "John Smith",
                    "employee_code" : "100007",
                    "jobposition" : "Senior Regional Manager",
                    "joining_date" : "2021-07-01",
                    "month" : "January",
                    "email" : "john.smith@abc.com",
                    "phone" : "+880196 225 2252",
                    "nationality" : "Bangladeshi",
                    "nid" : "9855506650545",
                    "passport" : "311564552565585",
                    "etin" : "100900256654",
                    "residency" : "Resident",
                    "gender" : "Male",
                    "marital_status" : "Married",
                    "status" : "Active",
                    "leaving_date" : "01-06-2023",
                    "department" : "Sale",
                    "branch" : "Motijheel",
                    "cost_center" : "Administration",
                    "pf_start_date" : "01-06-2023",
                    "pf_end_date" : "01-12-2023",
                    "service_period" : "47 Month(s)",
                    "membership_period" : "11 Month(s)",
                }
            }
        },
        methods:{
            showValue(str) {
                if(typeof this.default_data[str] != 'undefined' && this.default_data[str] != null)
                {
                    return this.default_data[str];
                }
                return '';

            },
            getcompany: function()
            {
                axios.get(this.$api_url+'/company/getcompany' , {
                    params: {

                    }
                }).then(function(response){
                    this.company_id = response.data;

                    if(this.company_id > 0)
                        this.getCompanyPFSettings();
                }.bind(this));
            },
            getCompanyPFSettings: function()
            {      let currentObj = this;

                   axios.get(this.$api_url+'/companypfsettings/'+this.company_id , {
                            params: {
                            }
                    }).then(function(response){
                    if(response.data.data){
                     this.company_pf_settings = response.data.data;
                     currentObj.company_pf_service_month =  (parseInt(this.company_pf_settings.pf_service_month_format.opt_value)==1) ? 'yes': 'no';

                    if(currentObj.company_pf_service_month == 'yes')
                    {
                        this.default_data.service_period = "3 Year(s) 11 Month(s)";
                        this.default_data.membership_period  = "0 Year(s) 11 Month(s)";

                    }

                    }
                    //this.validateState();
                }.bind(this));
            },
            downloadPreview()
            {

                this.loader = true;
                console.log('Posting to:', this.$api_url + '/company/payslip-field-settings/downlowad-preview');
                let final_array = [];
                final_array.push(this.default_data);
                final_array.push(this.company_data);
                final_array.push(this.header_left);
                final_array.push(this.header_right);
                final_array.push(this.footer);
                var text = JSON.stringify(final_array);

                  console.log('preview_data being sent:', text);

                let formData = new FormData();
                formData.append('preview_data', text);
                this.component_data = [];
                let currentObj = this;

                axios.post(this.$api_url + '/company/payslip-field-settings/downlowad-preview', formData)
                   .then(function (response)
                    {
                        currentObj.loader = false;
                        var fileURL = response.data.file_name;
                       // currentObj.download_file(fileURL)
                        this.downloadFileContent(fileURL);
                        //this.$bvToast.toast(response.data.message, {title: 'Success',variant: 'success',solid: true});

                    }.bind(this))
                    .catch(function (error)
                    {
                        this.loader = false;
                        //this.$bvToast.toast(error.response.data.errors.toString(), {title: 'Error!',variant: 'danger',solid: true});
                    });

            },
            download_file(fileURL)
            {
                if (!fileURL) return false;
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            stringView(str) {


                 if(str=='etin')
                {
                    str = 'e-TIN';
                    return str;
                }
                else if(str=='jobposition')
                {
                    str = 'Job Position';
                    return str;
                }
                else if(str=='nid')
                {
                    str = 'NID';
                    return str;
                }
                else if(str=='branch')
                {
                    str = 'Work Location';
                    return str;
                }

                else if(str=='name')
                {
                    str = 'Employee';
                    return str;
                }
                else if(str=='employee_code')
                {
                    str = 'Employee ID';
                    return str;
                }
                else if(str=='joining_date')
                {
                    str = 'Date of Joining';

                    return str;
                }
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },

        },
        created: function(){
          this.getcompany();
        },
        computed:
        {
            lengthCompute()
            {
                let x = this.header_left.length;
                let y = this.header_right.length;

                if(x >= y)
                {
                    this.data_length = x;
                }
                else if(y > x)
                {
                    this.data_length = y;
                }
                else
                {
                    this.data_length = 0;
                }

            }
        }
    }
</script>

<style scoped>
        .table{border: 1px solid #000000;border-collapse: collapse;width: 100%;padding: 10px 10px;}
       .table thead tr th{background: #d9d9d9;color: #d9d9d9;font-weight: bold;font-size: 11pt;border: 1px solid #000000; text-align: center;}
       .table tbody tr td{padding: 2px 10px 2px 10px;border: 1px solid #000000;border-collapse: collapse;}
       .text-center{text-align: center;}
       h5.text-center{margin: 0; padding: 8px 0;}
       .s-thead{background: #d9d9d9;color: #000;padding: 2px 5px;}
       .s-tfoot{background: #d9d9d9;padding: 2px 5px;}
       .mt-2{margin-top: 10px;padding: 0;line-height: 16px;}
       .list-unstyled{list-style: none;padding: 0;margin: 0;}
       .note{margin: 5px 0;padding: 0;}
       .s-section{background: #d9d9d9; font-size: 10px;}
       footer {
            border-top: 1px solid #000;
            position: fixed;
            bottom: -80px;
            left: 0px;
            right: 0px;
            height: 50px;
        }
        @page {
            margin: 100px 25px;
        }
        tr th, tr td, p, span, a, h5, li{
          font-family: sans-serif;
          font-size: 10pt;
        }
       .d-table{border-collapse: collapse;width: 100%;padding: 0px 5px;}
       .d-table tbody tr td{padding: 1px 5px 1px 5px;border-collapse: collapse;}
       .box-left{width: 49.5%;display: inline-block; vertical-align: top;}
       .box-right{width: 49.5%;display: inline-block; vertical-align: top;}
       body,html{margin-top: 1px;padding-top: 0;}

</style>

<style>
    .payslip-designer-overlay .b-overlay {height: 100% !important;}
</style>
